import React from "react";

import clsx from "clsx";
import { twMerge } from "tailwind-merge";

import { PrimaryButton } from "@shared/buttons";

import {
  PARTNER_TO_INFO_MAPPING,
  useUpsellEnhancedModel,
} from "./use-upsell-enhanced-model";

interface Props {
  className?: string;
}

export function ClicksAndViewsEnhancedModellingBanner({ className }: Props) {
  const {
    shouldDisplayUpsellBanner,
    upsellHeaderText,
    upsellBodyText,
    enabledPartnersForEnhancedModel,
    onDismissUpsellBanner,
    tryEnhancedModelButtonInfo,
    backgroundClassName,
  } = useUpsellEnhancedModel();

  if (!shouldDisplayUpsellBanner) {
    return null;
  }

  return (
    <div
      className={twMerge(
        "flex flex-row px-4 py-3 border-b",
        backgroundClassName,
        className,
      )}
    >
      {enabledPartnersForEnhancedModel.map((partner, index, partnersArray) => {
        const partnerInfo = PARTNER_TO_INFO_MAPPING[partner];
        const isLastPartner = index + 1 === partnersArray.length;

        return (
          <React.Fragment key={index}>
            <img
              src={partnerInfo.logo}
              width="30px"
              className={clsx(isLastPartner && "mr-4")}
              alt={`${partnerInfo.displayName} Logo`}
            />
            {!isLastPartner && (
              <i className="flex items-center fa-solid fa-plus text-2xl" />
            )}
          </React.Fragment>
        );
      })}
      <div className="text-xl">
        <div>
          <span className="font-semibold">{upsellHeaderText}</span>
        </div>
        <div>{upsellBodyText}</div>
      </div>
      <div className="ml-auto self-center flex items-center">
        <PrimaryButton
          className={tryEnhancedModelButtonInfo.className}
          onClick={tryEnhancedModelButtonInfo.onClick}
        >
          {tryEnhancedModelButtonInfo.text}
        </PrimaryButton>
        <div className="ml-5">
          <i
            className="fa-solid fa-xmark"
            role="button"
            onClick={onDismissUpsellBanner}
          />
        </div>
      </div>
    </div>
  );
}
